module.exports = __webpack_public_path__ + "img/features-2-mockup-mobile.12ca724b.png";